import React from "react";

const Showcase = () => {
  return <div>Portfolio</div>;
};

export default Showcase;
